import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';
import { ConversationSummary } from './list-conversations.query';

export interface ConversationTimelineItem {
  wamid?: string;
  timestamp: number;
  direction: 'inbound' | 'outbound';
  message_type?: string;
  /** Inbound content. Media carries `media_id` (Meta) or `media_url` (UltraMsg). */
  data?: { body?: string; [key: string]: unknown };
  payload?: { body?: string; type?: string; text?: { body?: string }; template_name?: string; [key: string]: unknown };
  delivery_status?: 'sent' | 'delivered' | 'read' | 'failed';
  /** Which of our numbers carried this message. */
  number_id?: string | null;
  /** `outside_admin`: sent from the line's own phone or the gateway's dashboard. */
  triggered_by?: { source?: string } | null;
}

type QueryResponse = {
  status: number;
  data: {
    conversation: ConversationSummary;
    timeline: ConversationTimelineItem[];
    total_messages: number;
    limit: number;
    offset: number;
  };
};

export const createGetConversationKey = (phone: string, additional: any[] = []) => [
  'get-conversation',
  phone,
  ...additional,
];

export const useGetConversationQuery = (
  phone: string,
  additionalProps = {},
  options: { refetchInterval?: number } = {},
) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while fetching the conversation',
    endpoint: `/api/admin/whatsapp/conversation/${encodeURIComponent(phone)}`,
  });

  return useQuery({
    queryKey: createGetConversationKey(phone, [additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    enabled: !!phone,
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
    refetchInterval: options.refetchInterval,
  });
};
